import PropTypes from 'prop-types'
import styled from 'astroturf/react'

import CheckboxInput from './inputs/checkbox'
import _Checkbox from "Checkbox.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/checkbox.js?styleId=Checkbox";
import _Label from "checkbox-Label.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/checkbox.js?styleId=Label";


const Checkbox = /*#__PURE__*/styled(CheckboxInput, null, {
  displayName: "Checkbox",
  styles: _Checkbox
})

const Label = /*#__PURE__*/styled('label', null, {
  displayName: "Label",
  styles: _Label
})

const CheckboxField = ({ className = null, label = null, ...inputProps }) => (
  <div className={className}>
    <Label>
      <Checkbox {...inputProps} />
      <div>{label}</div>
    </Label>
  </div>
)

CheckboxField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node
}

export default CheckboxField
